module.exports = __webpack_public_path__ + "static/media/headerLogo.a398097f.png";